/**
 * Shared chrome for non-dismissable modals. `Modal.Header` always renders its close
 * icon, so hiding it is a CSS override until the toolkit grows a prop for it.
 */
export const HIDE_CLOSE_BTN = '[&_[role=button]]:hidden!';
